import React, { useEffect, useState } from "react";

const Achievements = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div style={{ padding: isMobile ? "0 5px" : "0" }}>
            <section className="achievements">
                <div className="achievement">
                    <h3>10+</h3>
                    <p>Business Ventures</p>
                </div>

                <div className="achievement">
                    <h3>500+</h3>
                    <p>Successful Projects</p>
                </div>

                <div className="achievement">
                    <h3>10000+</h3>
                    <p>Satisfied Clients</p>
                </div>
            </section>
        </div>
    );
};

export default Achievements;